import { render, staticRenderFns } from "./depositDetail.vue?vue&type=template&id=43c647c4&scoped=true&"
import script from "./depositDetail.vue?vue&type=script&lang=js&"
export * from "./depositDetail.vue?vue&type=script&lang=js&"
import style0 from "./depositDetail.vue?vue&type=style&index=0&id=43c647c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c647c4",
  null
  
)

export default component.exports